import script from "./AboutSetupPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutSetupPage.vue?vue&type=script&setup=true&lang=js"

import "./AboutSetupPage.vue?vue&type=style&index=0&id=c0202bb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0202bb6"]])

export default __exports__